import { ExerciseProps } from '../../../types/Exercise.type';
import { ExerciseFormValues } from './ExerciseForm.type';

export interface EnhancedExerciseProps extends ExerciseProps {
  id?: string;
  exerciseType?: string;
  externalVideoUrl?: string;
}

export const formatExerciseForSubmission = (
  exerciseValues: EnhancedExerciseProps, 
  formData: ExerciseFormValues, 
  recordEnabled: boolean, 
  exerciseTypeSelected: string
): EnhancedExerciseProps => {
  return {
    ...exerciseValues,
    ...formData,
    recordEnabled,
    exerciseType: recordEnabled ? exerciseTypeSelected : undefined
  };
}; 